import Button from "@storeblocks/button";
import styled from "styled-components";

export const FormGroupWrap = styled.div`
  margin-bottom: 56px;
`;

export const RemoveChildButton = styled(Button)`
  margin-left: 12px;
`;

export const ChildDateOfBirthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 316px;

  & > div {
    margin-bottom: 12px;
  }
`;
